let refreshClickHandler;
if (typeof window !== "undefined") {
  refreshClickHandler = (routerParam) => routerParam.reload();
}

export default refreshClickHandler;
